import React from 'react';
import { TabsList, TabsTrigger } from '@/shared/ui/tabs';
import { AssetIcon } from '../../../../shared/assets';

const ICONS = {
  profile: 'nav.users',
  security: 'nav.settings',
  workspace: 'nav.dashboard',
};

export default function SettingsTabs({ showWorkspaceTab = false }) {
  const tabs = [
    { value: 'profile', label: 'Profilo' },
    { value: 'security', label: 'Sicurezza' },
    ...(showWorkspaceTab ? [{ value: 'workspace', label: 'Workspace' }] : []),
  ];

  return (
    <TabsList className={`settings-tabs ${showWorkspaceTab ? 'settings-tabs--three' : 'settings-tabs--two'}`}>
      {tabs.map((tab) => {
        return (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="settings-tabs__trigger"
          >
            <AssetIcon name={ICONS[tab.value]} size={16} />
            {tab.label}
          </TabsTrigger>
        );
      })}
    </TabsList>
  );
}
